import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'bazis-dummy-mobile',
    templateUrl: './dummy-mobile.component.html',
    imports: [TranslocoModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DummyMobileComponent {}
